module.exports = __webpack_public_path__ + "static/media/0212_Small.2e1160ce.jpg";